// eslint-disable-next-line no-restricted-imports
import { Container, Segment } from 'semantic-ui-react';

// Import component.
import PageHeader from '../Components/Shared/PageHeader';
import StudentsImporter from '../Components/Upload/StudentsImporter';
import { PAGE_NAMES, useSegmentPage } from '../segment';

const Importer = () => {
  useSegmentPage(PAGE_NAMES.importer);

  return (
    <Container className="no-padding no-margin">
      <PageHeader pageName={'Import your students list'} classes="importer" />

      <Segment basic>
        <StudentsImporter />
      </Segment>
    </Container>
  );
};

export default Importer;
